var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransferdom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 56 50",
    width: 56,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51 9L38 9L38 7L51 7L51 7L51 9ZM51 6L38 6L37 6L37 7L37 9L37 10L38 10L51 10L52 10L52 9L52 7L52 6L52 6L51 6Z",
    id: "hwv4FbvdI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9L17 9L17 7L19 7L19 7L19 9ZM19 6L17 6L16 6L16 7L16 9L16 10L17 10L19 10L20 10L20 9L20 7L20 6L20 6L19 6Z",
    id: "c3oOgKobF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9L11 9L11 7L13 7L13 7L13 9ZM13 6L11 6L10 6L10 7L10 9L10 10L11 10L13 10L14 10L14 9L14 7L14 6L14 6L13 6Z",
    id: "b23U6WukFb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9L5 9L5 7L7 7L7 7L7 9ZM7 6L5 6L4 6L4 7L4 9L4 10L5 10L7 10L8 10L8 9L8 7L8 6L8 6L7 6Z",
    id: "bS8jVfvtU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 48L55 48L55 3L1 3L1 48ZM2 47L2 13L54 13L54 47L2 47ZM2 12L2 4L54 4L54 12L2 12Z",
    id: "fceqdmLq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 42L17 34L9 34L9 42L17 42ZM16 35L16 41L10 41L10 35L16 35Z",
    id: "a2PyQcYIy8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 29L17 21L9 21L9 29L17 29ZM16 22L16 28L10 28L10 22L16 22Z",
    id: "bESJNmQgD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 40C23 40 23 40 23 40C23 41.2 23 41.87 23 42C23 42 23 42 23 42C21.8 42 21.13 42 21 42C21 42 21 42 21 42C21 40.8 21 40.13 21 40C21 40 21 40 21 40C22.2 40 22.87 40 23 40Z",
    id: "c96cTqW1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27C23 27 23 27 23 27C23 28.2 23 28.87 23 29C23 29 23 29 23 29C21.8 29 21.13 29 21 29C21 29 21 29 21 29C21 27.8 21 27.13 21 27C21 27 21 27 21 27C22.2 27 22.87 27 23 27Z",
    id: "bxj9EEa0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 38L33 35L32 35L32 41L33 41L33 39L37 39L37 38L37 35L36 35L36 38L33 38Z",
    id: "a9fCn2xN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 41C37 41 37 41 37 41C37 41.6 37 41.93 37 42C37 42 37 42 37 42C34.6 42 33.27 42 33 42C33 42 33 42 33 42C33 41.4 33 41.07 33 41C33 41 33 41 33 41C35.4 41 36.73 41 37 41Z",
    id: "fcKwMam46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 34C36 34 36 34 36 34C36 34.6 36 34.93 36 35C36 35 36 35 36 35C34.2 35 33.2 35 33 35C33 35 33 35 33 35C33 34.4 33 34.07 33 34C33 34 33 34 33 34C34.8 34 35.8 34 36 34Z",
    id: "d2r5nNdMoX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 22C37 22 37 22 37 22C37 25.6 37 27.6 37 28C37 28 37 28 37 28C36.4 28 36.07 28 36 28C36 28 36 28 36 28C36 24.4 36 22.4 36 22C36 22 36 22 36 22C36.6 22 36.93 22 37 22Z",
    id: "aHjA3SOX1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 22C33 22 33 22 33 22C33 25.6 33 27.6 33 28C33 28 33 28 33 28C32.4 28 32.07 28 32 28C32 28 32 28 32 28C32 24.4 32 22.4 32 22C32 22 32 22 32 22C32.6 22 32.93 22 33 22Z",
    id: "i1fH9JtSYh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 28C36 28 36 28 36 28C36 28.6 36 28.93 36 29C36 29 36 29 36 29C34.2 29 33.2 29 33 29C33 29 33 29 33 29C33 28.4 33 28.07 33 28C33 28 33 28 33 28C34.8 28 35.8 28 36 28Z",
    id: "h6zXU5IiKg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 21C36 21 36 21 36 21C36 21.6 36 21.93 36 22C36 22 36 22 36 22C34.2 22 33.2 22 33 22C33 22 33 22 33 22C33 21.4 33 21.07 33 21C33 21 33 21 33 21C34.8 21 35.8 21 36 21Z",
    id: "gjLO2mDPu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22C26 22 26 22 26 22C26 25.6 26 27.6 26 28C26 28 26 28 26 28C25.4 28 25.07 28 25 28C25 28 25 28 25 28C25 24.4 25 22.4 25 22C25 22 25 22 25 22C25.6 22 25.93 22 26 22Z",
    id: "fh1hZO1tR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 21C29 21 29 21 29 21C29 21.6 29 21.93 29 22C29 22 29 22 29 22C27.2 22 26.2 22 26 22C26 22 26 22 26 22C26 21.4 26 21.07 26 21C26 21 26 21 26 21C27.8 21 28.8 21 29 21Z",
    id: "ejdsAlJmd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 29L30 27L29 27L29 28L26 28L26 29L29 29L30 29Z",
    id: "cHKKeNBth"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22C30 22 30 22 30 22C30 23.2 30 23.87 30 24C30 24 30 24 30 24C29.4 24 29.07 24 29 24C29 24 29 24 29 24C29 22.8 29 22.13 29 22C29 22 29 22 29 22C29.6 22 29.93 22 30 22Z",
    id: "bcLBXLJOj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 34L25 42L26 42L26 36L27 36L27 35L26 35L26 34L25 34Z",
    id: "bqtWL9FWj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 34C29 34 29 34 29 34C29 34.6 29 34.93 29 35C29 35 29 35 29 35C27.8 35 27.13 35 27 35C27 35 27 35 27 35C27 34.4 27 34.07 27 34C27 34 27 34 27 34C28.2 34 28.87 34 29 34Z",
    id: "j80KLju2J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35C30 35 30 35 30 35C30 39.2 30 41.53 30 42C30 42 30 42 30 42C29.4 42 29.07 42 29 42C29 42 29 42 29 42C29 37.8 29 35.47 29 35C29 35 29 35 29 35C29.6 35 29.93 35 30 35Z",
    id: "i86txVPXfX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 21L39 29L40 29L40 23L41 23L41 22L40 22L40 21L39 21Z",
    id: "e8uG2DWlE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 21C47 21 47 21 47 21C47 21.6 47 21.93 47 22C47 22 47 22 47 22C45.8 22 45.13 22 45 22C45 22 45 22 45 22C45 21.4 45 21.07 45 21C45 21 45 21 45 21C46.2 21 46.87 21 47 21Z",
    id: "a6XqHVWCxE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 22C48 22 48 22 48 22C48 26.2 48 28.53 48 29C48 29 48 29 48 29C47.4 29 47.07 29 47 29C47 29 47 29 47 29C47 24.8 47 22.47 47 22C47 22 47 22 47 22C47.6 22 47.93 22 48 22Z",
    id: "d4OSpvbNje"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 21C43 21 43 21 43 21C43 21.6 43 21.93 43 22C43 22 43 22 43 22C41.8 22 41.13 22 41 22C41 22 41 22 41 22C41 21.4 41 21.07 41 21C41 21 41 21 41 21C42.2 21 42.87 21 43 21Z",
    id: "a41tz4fPDJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 29L44 29L44 23L45 23L45 22L44 22L43 22L43 29Z",
    id: "df0KmXCyR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32L40 34L39 34L39 35L40 35L40 41L41 41L41 35L43 35L43 34L41 34L41 32L40 32Z",
    id: "a7V6GyCme"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 41C43 41 43 41 43 41C43 41.6 43 41.93 43 42C43 42 43 42 43 42C41.8 42 41.13 42 41 42C41 42 41 42 41 42C41 41.4 41 41.07 41 41C41 41 41 41 41 41C42.2 41 42.87 41 43 41Z",
    id: "gbrx1JI5u"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hwv4FbvdI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hwv4FbvdI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3oOgKobF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3oOgKobF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b23U6WukFb",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b23U6WukFb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bS8jVfvtU",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bS8jVfvtU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fceqdmLq",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fceqdmLq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2PyQcYIy8",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2PyQcYIy8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bESJNmQgD",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bESJNmQgD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c96cTqW1a",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c96cTqW1a",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bxj9EEa0z",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bxj9EEa0z",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9fCn2xN",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9fCn2xN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fcKwMam46",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fcKwMam46",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2r5nNdMoX",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2r5nNdMoX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aHjA3SOX1",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aHjA3SOX1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1fH9JtSYh",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1fH9JtSYh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6zXU5IiKg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h6zXU5IiKg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gjLO2mDPu",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gjLO2mDPu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fh1hZO1tR",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fh1hZO1tR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ejdsAlJmd",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ejdsAlJmd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cHKKeNBth",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cHKKeNBth",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcLBXLJOj",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcLBXLJOj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqtWL9FWj",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqtWL9FWj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j80KLju2J",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j80KLju2J",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i86txVPXfX",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i86txVPXfX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e8uG2DWlE",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e8uG2DWlE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6XqHVWCxE",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6XqHVWCxE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4OSpvbNje",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4OSpvbNje",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a41tz4fPDJ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a41tz4fPDJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#df0KmXCyR",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#df0KmXCyR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7V6GyCme",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7V6GyCme",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gbrx1JI5u",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gbrx1JI5u",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransferdom);
export default __webpack_public_path__ + "static/media/icon-transferdom.9ebe75e4e0a3a9ac49f81a21dd5f5baa.svg";
export { ForwardRef as ReactComponent };